const ALPHABET = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

function randomBytes(n: number): Uint8Array {
  const out = new Uint8Array(n);
  const c = (globalThis as { crypto?: Crypto }).crypto;
  if (c?.getRandomValues) c.getRandomValues(out);
  else for (let i = 0; i < n; i++) out[i] = Math.floor(Math.random() * 256);
  return out;
}

let counter = 0;
let deterministic: string | null = null;

/** Generates a short, URL-safe unique id. */
export function createId(prefix = "n"): string {
  if (deterministic !== null) return `${prefix}_${deterministic}${(++counter).toString(36)}`;
  const bytes = randomBytes(10);
  let s = "";
  for (const b of bytes) s += ALPHABET[b % ALPHABET.length];
  return `${prefix}_${s}`;
}

/** Tests: makes ids predictable. Pass null to restore random ids. */
export function setDeterministicIds(seed: string | null): void {
  deterministic = seed;
  counter = 0;
}
